/* eslint-disable prefer-destructuring */
declare global {
  interface Window {
    FB: fb.FacebookStatic
  }
}

const FACEBOOK_APP_ID = process.env.SITE_URL === 'campus.quipper.com' ? '566600453438974' : '664828286949523'
const version = 'v20.0'

export const windowFBInit = async () => {
  if (window.FB) {
    window.FB.init({
      appId: FACEBOOK_APP_ID,
      cookie: true,
      xfbml: true,
      version,
    })
  }
}

export const loadSDKAsync = () => {
  // Load the SDK asynchronously
  const fjs = document.getElementsByTagName('script')[0]
  if (document.getElementById('facebook-jssdk')) return
  const js = document.createElement('script')
  js.id = 'facebook-jssdk'
  js.src =
    'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=' +
    version +
    '&appId=' +
    FACEBOOK_APP_ID +
    '&autoLogAppEvents=1'
  fjs?.parentNode?.insertBefore(js, fjs)
}

export const FBLogin = (
  callback: (param: fb.StatusResponse) => void,
  errCallback?: (param?: fb.StatusResponse) => void
) => {
  if (window.FB) {
    window.FB.login(
      (response) => {
        if (response.status === 'connected') {
          // Logged into your webpage and Facebook.
          callback(response)
        } else {
          errCallback && errCallback(response)
        }
      },
      // eslint-disable-next-line @typescript-eslint/camelcase
      { scope: 'email', return_scopes: true }
    )
  }
}
